import React from "react";
import Exper from "./experi";
import "./style.css"

const academy = () => {
  return (
      <div className="container">
        <Exper></Exper>
        <br/><br/>
      </div>
  );
};
export default academy;
